import React from 'react';
import { Form, InputGroup } from 'react-bootstrap';

import RequiredIndicator from './RequiredIndicator';
import ValidationFeedback from './ValidationFeedback';

const FormControl = React.forwardRef(function (
  { type, className, controlId, label, required, prefix, suffix, errors, ...props },
  ref
) {
  return (
    <Form.Group
      className={`w-100 ${className ? className : ''}`}
      controlId={controlId}>
      {label && (
        <Form.Label>
          {label}
          <RequiredIndicator required={required} />
        </Form.Label>
      )}
      <InputGroup size={props.size}>
        {prefix &&
          (typeof prefix === 'object' ? (
            prefix
          ) : (
            <InputGroup.Text>{prefix}</InputGroup.Text>
          ))}
        <Form.Control
          ref={ref}
          required={required}
          type={type || 'text'}
          {...props}
        />
        {suffix &&
          (typeof suffix === 'object' ? (
            suffix
          ) : (
            <InputGroup.Text>{suffix}</InputGroup.Text>
          ))}
      </InputGroup>
      <ValidationFeedback errors={errors} className='d-block' />
    </Form.Group>
  );
});

export default FormControl;